module.exports = __webpack_public_path__ + "static/media/portrait-mode.43ff33dd.svg";